<div class="footer">
  @if (effectivePreviousVisible()) {
    <button [disabled]="!previousEnabled()" (click)="previous()">{{previousTitle()}}</button>
  }
  @if (nextVisible()) {
    <button [disabled]="!nextEnabled()" (click)="next()">{{effectiveNextTitle()}}</button>
  }
</div>
